import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Untersuchungsmaterial } from '../untersuchungsmaterial';

@Component({
    selector: 'kiene-untersuchungsmaterial-konfigurator-dialog',
    templateUrl: './untersuchungsmaterial-konfigurator-dialog.component.html',
    styleUrls: ['./untersuchungsmaterial-konfigurator-dialog.component.scss'],
})
export class UntersuchungsmaterialKonfiguratorDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<UntersuchungsmaterialKonfiguratorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public material: Untersuchungsmaterial,
    ) {}

    ngOnInit(): void {}

    untersuchungsmaterialChanged(untersuchungsmaterial: Untersuchungsmaterial) {
        this.dialogRef.close(untersuchungsmaterial);
    }
}
